/**
 * i18n helper — reads from window.FcaEventsConfig.i18n
 * Custom translation overrides are stored server-side and merged into
 * the i18n config by PHP before it reaches the frontend.
 */

export function __(key) {
  const i18n = (window.FcaEventsConfig || {}).i18n || {}
  return i18n[key] !== undefined ? i18n[key] : key
}

/**
 * Formatted i18n — translates key then replaces %placeholder% tokens.
 * Usage: __f('page_x_of_y', { current: 1, total: 5 }) → "Page 1 of 5"
 */
export function __f(key, replacements = {}) {
  let str = __(key)
  Object.entries(replacements).forEach(([k, v]) => {
    str = str.replace(new RegExp(`%${k}%`, 'g'), v)
  })
  return str
}

/**
 * Get all translation keys (for the translations editor).
 */
export function getAllTranslationKeys() {
  const i18n = (window.FcaEventsConfig || {}).i18n || {}
  return Object.keys(i18n)
}
